import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShortcutService {

private readonly triggerSubject = new Subject<void>();
  trigger$ = this.triggerSubject.asObservable();

  triggerShortcut() {
    this.triggerSubject.next();
  }
}
